import React from 'react';
import './footericon.css';
import facebookImg from '../../asserts/Link.png';
import twitterImg from '../../asserts/Link1.png';
import instagramImg from '../../asserts/link2.png';

const FooterIcon = ({ type }) => {
    if (type === 'facebook') {
        return (
            <div className='social-icon-wrap'>
                <img src={facebookImg} alt="Facebook" className='social-img' />
            </div>
        );
    }

    if (type === 'twitter') {
        return (
            <div className='social-icon-wrap'>
                <img src={twitterImg} alt="Twitter" className='social-img' />
            </div>
        );
    }

    if (type === 'instagram') {
        return (
            <div className='social-icon-wrap'>
                <img src={instagramImg} alt="Instagram" className='social-img' />
            </div>
        );
    }

    return null;
};

export default FooterIcon;